"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const button_1 = require("@kyruus/button");
const intl_1 = require("@kyruus/intl");
const ArrowLeft_1 = __importDefault(require("@kyruus/react-ikons/ArrowLeft"));
const react_1 = require("@xstate/react");
const react_2 = __importDefault(require("react"));
const PhoneNumberLink_1 = __importDefault(require("../../../components/PhoneNumberLink/PhoneNumberLink"));
const useWindowWidth_1 = __importDefault(require("../../../lib/useWindowWidth"));
const utils_1 = require("../../../lib/utils");
const useManageAppointmentContext_1 = require("../../../ManageAppointment/hooks/useManageAppointmentContext");
const constant_1 = require("../../lib/constants/constant");
const Tracking_1 = require("../../lib/constants/Tracking");
const xstate_1 = require("../../lib/constants/xstate");
const messages_1 = __importDefault(require("../../lib/messages"));
const styles_1 = require("./styles");
const cancellationReasontoSelectAdapter = (cancellationReasons) => cancellationReasons.map((reason) => ({
    value: reason.code,
    label: reason.text
}));
/**
 * Helper function to determine manage appointment URL
 * @returns {string} The URL for the manage appointment page
 */
const getManageAppointmentUrl = () => {
    const currentUrl = window.location.pathname;
    const rescheduleManageAppointmentId = currentUrl
        .split('/')
        .filter((item) => item !== '')
        .pop();
    return `/${constant_1.MANAGE_APPOINTMENT}/${rescheduleManageAppointmentId}`;
};
const CancelPage = ({ service, intl }) => {
    var _a, _b;
    const [state, send] = (0, react_1.useService)(service);
    const { context } = state;
    const { aboveMd } = (0, useWindowWidth_1.default)();
    const { track } = (0, useManageAppointmentContext_1.useManageAppointmentContext)();
    const hasError = state.matches(`${xstate_1.states.cancelPage}.${xstate_1.states.cancelError}`);
    const isAppointmentCancelling = state.matches(`${xstate_1.states.cancelPage}.${xstate_1.states.cancelingAppointment}`);
    const shouldRenderBackButton = ((_a = context === null || context === void 0 ? void 0 : context.capabilities) === null || _a === void 0 ? void 0 : _a.isRescheduleEnabled) && aboveMd;
    let phone;
    if (context.provider) {
        const { provider } = context;
        phone = (0, utils_1.getMainContactNumber)(provider);
    }
    const handleCancelAppointment = () => {
        var _a;
        send({
            type: xstate_1.events.cancel,
            data: {
                cancellationReason: state.context.selectedCancellationReason
            }
        });
        track(Tracking_1.userEvents.CLICK_CANCEL_APPT, state.context.selectedCancellationReason && {
            [Tracking_1.REASON_GIVEN]: (_a = state.context.selectedCancellationReason) === null || _a === void 0 ? void 0 : _a.text
        });
    };
    const onReasonChange = (event) => {
        const selectedReason = state.context.cancellationReasons.find((reason) => reason.code === event.currentTarget.value);
        if (selectedReason) {
            send({
                type: xstate_1.events.selectCancellationReason,
                data: selectedReason
            });
            track(Tracking_1.userEvents.CANCELLATION_REASON_SELECTED, {
                [Tracking_1.REASON_GIVEN]: selectedReason.text
            });
        }
    };
    const errorBanner = (react_2.default.createElement(styles_1.StyledErrorBanner, { isDesktop: aboveMd, type: "warning", icon: "!", "data-testid": "cancelFailedErrorBanner" },
        react_2.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.cancelationDisabledBanner, { values: phone
                ? {
                    phone_number_link: react_2.default.createElement(PhoneNumberLink_1.default, { phone: phone })
                }
                : undefined }))));
    const handleBackButtonClick = () => {
        track(Tracking_1.userEvents.APPT_CANCEL_BACK_BUTTON_CLICK);
    };
    return (react_2.default.createElement(styles_1.CancelContentContainer, { "data-testid": "CancelPage" },
        shouldRenderBackButton && (react_2.default.createElement(styles_1.StyledBackButton, { "data-testid": "backButton", icon: react_2.default.createElement(ArrowLeft_1.default, { "aria-hidden": "true" }), iconAlign: "left", mode: "flat", active: true, onClick: handleBackButtonClick, href: getManageAppointmentUrl() },
            react_2.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.goBack)))),
        aboveMd && hasError && errorBanner,
        react_2.default.createElement(styles_1.StyledCancelPageHeader, null,
            react_2.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.selectReasonAlert))),
        react_2.default.createElement(styles_1.StyledSelect, { isDesktop: aboveMd, onChange: onReasonChange, value: ((_b = state.context.selectedCancellationReason) === null || _b === void 0 ? void 0 : _b.code) || '', placeholder: intl.formatMessage(messages_1.default.reasonPlaceholder), disabled: false, name: 'cancellationReason', label: intl.formatMessage(messages_1.default.reasonLabel), options: cancellationReasontoSelectAdapter(state.context.cancellationReasons || []), "data-testid": "cancellationReason" }),
        !aboveMd && hasError && errorBanner,
        react_2.default.createElement(styles_1.ButtonContainer, { isDesktop: aboveMd },
            react_2.default.createElement(button_1.ButtonWithSpinner, { onClick: handleCancelAppointment, showSpinner: isAppointmentCancelling, disabled: isAppointmentCancelling, "data-testid": "cancelAppointmentButton" },
                react_2.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.cancelApptButton))))));
};
exports.default = (0, intl_1.injectIntl)(CancelPage);
//# sourceMappingURL=CancelPage.js.map